import { render } from "./MenusList.vue?vue&type=template&id=8497eb78&scoped=true"
import script from "./MenusList.vue?vue&type=script&lang=js"
export * from "./MenusList.vue?vue&type=script&lang=js"

import "./MenusList.vue?vue&type=style&index=0&id=8497eb78&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8497eb78"]])

export default __exports__